const DateCell = ({ date }) => {
  const d = new Date(date);

  return (
    <>
      {d.getDate()}-
      {d.getMonth() + 1}-
      {d.getFullYear()}
      <br />
      {d.toLocaleTimeString()}
    </>
  );
};

export default DateCell;